function Address(firstName, middleName, lastName, fullName, address1, address2, address3, city, state, postalCode, countryCode, phone1, phone2) {
	if(firstName !== undefined){
		this.FirstName = firstName;
	}
	if(middleName !== undefined){
		this.MiddleName = middleName;
	}
	if(lastName !== undefined){
		this.LastName = lastName;
	}
	if(fullName !== undefined){
		this.FullName = fullName;
	}
	if(address1 !== undefined){
		this.Address1 = address1;	
	}
	if(address2 !== undefined){
		this.Address2 = address2;	
	}
	if(address3 !== undefined){
		this.Address3 = address3;	
	}
	if(city !== undefined){
		this.City = city;
	}
	if(state !== undefined){
		this.State = state;
	}
	if(postalCode !== undefined){
		this.PostalCode = postalCode;
	}
	if(countryCode !== undefined){
		this.CountryCode = countryCode;
	}
	if(phone1 !== undefined){
		this.Phone1 = phone1;
	}
	if(phone2 !== undefined){
		this.Phone2 = phone2;
	}
}

module.exports = Address;


//////////////////
// WEBPACK FOOTER
// ./models/address.js
// module id = 40
// module chunks = 0 5 20